import { Component, inject, input, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { Store } from '@ngrx/store';
import {
  navigateToOrigin,
  navigateToOriginLogin,
} from '../../core/state/mfa/mfa.actions';
import { MfaErrors } from '../../core/state/mfa/mfa.state';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-mfa-fail',
  imports: [
    TranslateModule,
    MatButton,
    MatIcon,
    NgOptimizedImage,
    AsyncPipe,
    MatIconButton,
  ],
  templateUrl: './mfa-fail.component.html',
  styleUrl: './mfa-fail.component.scss',
})
export class MfaFailComponent {
  errorType: Signal<MfaErrors> = input<MfaErrors>();

  private store = inject(Store);

  navigateToOrigin() {
    this.store.dispatch(navigateToOrigin({}));
  }

  navigateToOriginLogin(isTimedOut: boolean) {
    this.store.dispatch(
      navigateToOriginLogin({
        isTimedOut,
      }),
    );
  }

  protected readonly MfaErrors = MfaErrors;
}
